module.exports = __webpack_public_path__ + "img/icon_arrow_left.64c9035f.png";